import { render, staticRenderFns } from "./client-profile-collaborators.vue?vue&type=template&id=1f9433b9"
import script from "./client-profile-collaborators.vue?vue&type=script&lang=js"
export * from "./client-profile-collaborators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports